import React from "react";
import SEO from "../components/SEO";
import PageHero from "@/components/site/PageHero";
import FoundingStory from "@/components/site/about/FoundingStory";
import Beliefs from "@/components/site/about/Beliefs";
import TeamContact from "@/components/site/about/TeamContact";

export default function About() {
  return (
    <>
      <SEO
        title="About LabComplyx — Lab Compliance Documentation for CLIA and FDA Regulated Labs"
        description="LabComplyx is a governed documentation workflow for laboratory and quality teams, built by Irvin Palmer, a laboratory and quality professional with 15+ years in regulated environments. Based in NC. Serving labs nationwide."
        keywords="regulated lab compliance support, audit-ready documentation, inspection readiness, QA documentation, CAPA support, SOP management, compliance consulting"
        canonical="https://labcomplyx.com/about"
        ogUrl="https://labcomplyx.com/about"
        breadcrumbs={[
          { name: "Home", url: "https://labcomplyx.com/" },
          { name: "About", url: "https://labcomplyx.com/about" },
        ]}
        schema={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "About LabComplyx — Lab Compliance Documentation for CLIA and FDA Regulated Labs",
          "description": "LabComplyx is a governed documentation workflow for laboratory and quality teams, built by Irvin Palmer, a laboratory and quality professional with 15+ years in regulated environments. Based in NC. Serving labs nationwide.",
          "url": "https://labcomplyx.com/about",
          "publisher": { "@id": "https://labcomplyx.com/#organization" },
          "mainEntity": {
            "@type": "Person",
            "name": "Irvin Palmer",
            "jobTitle": "Founder, LabComplyx LLC",
            "worksFor": { "@id": "https://labcomplyx.com/#organization" },
            "knowsAbout": ["CLIA Compliance", "FDA Regulations", "CAP Accreditation", "GxP Documentation", "CAPA", "SOP Management"],
            "areaServed": { "@type": "Country", "name": "United States" }
          },
        }}
      />
      <PageHero
        title="Why LabComplyx exists"
        sub="LabComplyx was built by a laboratory and quality professional with more than 15 years of experience in regulated environments. Across laboratory operations, analytical testing, quality oversight, and inspection readiness, the same problem kept appearing: capable teams knew the science and had performed the work, but turning scattered information into complete, review-ready documentation consumed time and created avoidable backlogs."
      />
      <FoundingStory />
      <Beliefs />
      <TeamContact />
    </>
  );
}